import React from 'react';
interface ImagePlaceholderProps {
  alt: string;
  className?: string;
}
export function ImagePlaceholder({
  alt,
  className = ''
}: ImagePlaceholderProps) {
  return <div role="img" aria-label={alt} className={['flex flex-col justify-end border border-brass/40 bg-paper p-5 rounded-sharp', className].join(' ')} data-id="element-145" data-mp="w4uwmtvmvdw5">
      <div aria-hidden="true" className="mb-5 space-y-2" data-id="element-146" data-mp="3g75iho7duao">
        <span className="block h-px w-full bg-brass/25" data-id="element-147" data-mp="3gpaq3sufiuq" />
        <span className="block h-px w-4/5 bg-brass/25" data-id="element-148" data-mp="3un0i0hog5fui" />
        <span className="block h-px w-3/5 bg-brass/25" data-id="element-149" data-mp="3uobia7ioo5gv" />
      </div>
      <p className="font-mono text-[10px] uppercase leading-[1.5] tracking-label text-slate/70" data-id="element-150" data-mp="d722oh2zmeaw">
        IMAGE — {alt}
      </p>
    </div>;
}